import { __decorate, __metadata } from "tslib";
import { SerializableObject, SerializableMember, NumberType } from '../../data/decorators';
import * as THREE from './_internal';
/**
 * Serializable THREE.js Vector2
 */
let Vector2 = class Vector2 extends THREE.Vector2 {
  static fromArray(array) {
    return new this().fromArray(array);
  }
  clone() {
    return new this.constructor().copy(this);
  }
};
__decorate([SerializableMember({
  numberType: NumberType.DECIMAL
}), __metadata("design:type", Number)], Vector2.prototype, "x", void 0);
__decorate([SerializableMember({
  numberType: NumberType.DECIMAL
}), __metadata("design:type", Number)], Vector2.prototype, "y", void 0);
Vector2 = __decorate([SerializableObject()], Vector2);
export { Vector2 };